import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Entrys/Get`, payload),
    GetByFactorID: (payload) => Repository.post(`/api/Entrys/GetByFactorID`, payload),
    GetNotifyByFactorID: (payload) => Repository.post(`/api/Entrys/GetNotifyByFactorID`, payload),
    GetActive: (payload) => Repository.post(`/api/Entrys/GetActive`, payload),
}
